import { _ as _defineProperty } from './defineProperty-Y-S4SptN.js';
import { _ as _slicedToArray } from './slicedToArray-ibbgR3-O.js';
import { useState, useEffect, useCallback, cloneElement } from 'react';
import { createPortal } from 'react-dom';
import { usePopper } from 'react-popper';
import useClickOutside from './useClickOutsideRef/index.js';
import noop from './noop/index.js';
import createUseStyles from './create/index.js';
import { j as jsxRuntimeExports } from './jsx-runtime-KJzvSKZ_.js';

var PopperEvent = /*#__PURE__*/function (PopperEvent) {
  PopperEvent["Click"] = "click";
  PopperEvent["Hover"] = "hover";
  return PopperEvent;
}({});

function ownKeys$1(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread$1(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys$1(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys$1(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var arrowBorder = {
  content: '""',
  position: 'absolute',
  marginLeft: -10
};
var useStyles = createUseStyles({
  overlay: {
    position: 'fixed',
    left: 0,
    right: 0,
    top: 0,
    bottom: 0,
    zIndex: 999999
  },
  popperElement: {
    '--arrowHeight': '9px',
    zIndex: 1000000,
    '&[data-popper-reference-hidden=true]': {
      visibility: 'hidden',
      pointerEvents: 'none',
      opacity: 0
    },
    '&[data-popper-placement*=bottom]': {
      '& > div[data-popper-arrow]': {
        top: 'calc(var(--arrowHeight) * (-1))',
        borderBottom: '9px solid var(--backgrounds-tint-2)',
        borderLeft: '7px solid transparent',
        borderRight: '7px solid transparent',
        marginTop: 1,
        '&:after': _objectSpread$1(_objectSpread$1({}, arrowBorder), {}, {
          marginTop: 2,
          borderLeft: '10px solid transparent',
          borderRight: '10px solid transparent',
          borderBottom: '12px solid var(--backgrounds-tint-1)'
        })
      }
    },
    '&[data-popper-placement*=top]': {
      '& > div[data-popper-arrow]': {
        bottom: 'calc(var(--arrowHeight) * (-1))',
        borderTop: '9px solid var(--backgrounds-tint-2)',
        borderLeft: '7px solid transparent',
        borderRight: '7px solid transparent',
        '&:after': _objectSpread$1(_objectSpread$1({}, arrowBorder), {}, {
          marginTop: -14,
          borderLeft: '10px solid transparent',
          borderRight: '10px solid transparent',
          borderTop: '12px solid var(--backgrounds-tint-1)'
        })
      }
    },
    '&[data-popper-placement*=left]': {
      '& > div[data-popper-arrow]': {
        right: 'calc(var(--arrowHeight) * (-1))',
        borderLeft: '9px solid var(--backgrounds-tint-2)',
        borderTop: '7px solid transparent',
        borderBottom: '7px solid transparent',
        marginRight: -4,
        '&:after': _objectSpread$1(_objectSpread$1({}, arrowBorder), {}, {
          marginLeft: -14,
          marginTop: -10,
          borderTop: '10px solid transparent',
          borderBottom: '10px solid transparent',
          borderLeft: '12px solid var(--backgrounds-tint-1)'
        })
      }
    },
    '&[data-popper-placement*=right]': {
      '& > div[data-popper-arrow]': {
        left: 'calc(var(--arrowHeight) * (-1))',
        borderRight: '9px solid var(--backgrounds-tint-2)',
        borderTop: '7px solid transparent',
        borderBottom: '7px solid transparent',
        marginLeft: -4,
        '&:after': _objectSpread$1(_objectSpread$1({}, arrowBorder), {}, {
          marginLeft: 7,
          marginTop: -10,
          borderTop: '10px solid transparent',
          borderBottom: '10px solid transparent',
          borderRight: '12px solid var(--backgrounds-tint-1)'
        })
      }
    }
  },
  arrow: {
    zIndex: '-1',
    width: 14,
    height: 9
  }
}, {
  name: 'popper'
});

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var arrowHeight = 10;
var getPopperContent = function getPopperContent(content) {
  return /*#__PURE__*/createPortal(content, document.body);
};
function Popper(_ref) {
  var target = _ref.target,
    content = _ref.content,
    _ref$placement = _ref.placement,
    placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
    offset = _ref.offset,
    _ref$trigger = _ref.trigger,
    trigger = _ref$trigger === void 0 ? PopperEvent.Click : _ref$trigger,
    interactable = _ref.interactable,
    enableArrow = _ref.enableArrow,
    mouseEnterDelay = _ref.mouseEnterDelay,
    mouseLeaveDelay = _ref.mouseLeaveDelay,
    isVisible = _ref.isVisible,
    _ref$onVisibleChange = _ref.onVisibleChange,
    onVisibleChange = _ref$onVisibleChange === void 0 ? noop : _ref$onVisibleChange,
    isOpen = _ref.isOpen,
    useOverlayForOutsideClick = _ref.useOverlayForOutsideClick,
    dataTestId = _ref.dataTestId,
    _ref$buttonDataTestId = _ref.buttonDataTestId,
    buttonDataTestId = _ref$buttonDataTestId === void 0 ? 'popper-button' : _ref$buttonDataTestId,
    preventOutSideClick = _ref.preventOutSideClick;
  var classes = useStyles();
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    targetRef = _useState2[0],
    setTargetElement = _useState2[1];
  var _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    popperElement = _useState4[0],
    setPopperElement = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    arrowElement = _useState6[0],
    setArrowElement = _useState6[1];
  var _usePopper = usePopper(targetRef, popperElement, {
      modifiers: [{
        name: 'offset',
        options: {
          // @ts-ignore
          offset: offset !== null && offset !== void 0 ? offset : enableArrow ? [0, arrowHeight] : [0, 0]
        }
      }, {
        name: 'arrow',
        options: {
          element: arrowElement,
          padding: 10
        }
      }],
      placement: placement
    }),
    styles = _usePopper.styles,
    attributes = _usePopper.attributes;
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    show = _useState8[0],
    setShow = _useState8[1];
  var isControlled = isOpen !== undefined;
  var closeContent;
  var openContent;
  useEffect(function () {
    onVisibleChange(show);
  }, [show, onVisibleChange]);
  var toggle = function toggle() {
    setShow(function (prev) {
      return !prev;
    });
  };
  var hide = useCallback(function (e) {
    popperElement && !popperElement.contains(e.target) && !isControlled && !preventOutSideClick && setShow(false);
  }, [preventOutSideClick, isControlled, popperElement]);
  var popperContentRef = useClickOutside(hide);
  var getContent = function getContent() {
    return /*#__PURE__*/jsxRuntimeExports.jsxs(jsxRuntimeExports.Fragment, {
      children: [/*#__PURE__*/jsxRuntimeExports.jsxs("div", _objectSpread(_objectSpread({
        ref: function ref(_ref3) {
          return setPopperElement(_ref3);
        },
        onMouseEnter: interactable && trigger !== PopperEvent.Click ? open : noop,
        onMouseLeave: interactable && trigger !== PopperEvent.Click ? close : noop,
        style: styles.popper
      }, attributes.popper), {}, {
        className: classes.popperElement,
        "data-popper-content": true,
        children: [enableArrow && /*#__PURE__*/jsxRuntimeExports.jsx("div", {
          ref: function ref(_ref2) {
            return setArrowElement(_ref2);
          },
          style: styles.arrow,
          className: classes.arrow,
          "data-popper-arrow": true
        }), /*#__PURE__*/jsxRuntimeExports.jsx("div", {
          "data-testid": dataTestId,
          children: content
        })]
      })), useOverlayForOutsideClick && /*#__PURE__*/jsxRuntimeExports.jsx("div", {
        className: classes.overlay,
        onClick: closeFromOverlay
      })]
    });
  };
  var open = function open() {
    clearTimeout(closeContent);
    mouseEnterDelay ? openContent = setTimeout(function () {
      return setShow(true);
    }, mouseEnterDelay) : setShow(true);
  };
  var close = function close() {
    clearTimeout(openContent);
    mouseLeaveDelay ? closeContent = setTimeout(function () {
      return setShow(false);
    }, mouseLeaveDelay) : setShow(false);
  };
  var closeFromOverlay = function closeFromOverlay(e) {
    e.stopPropagation();
    setShow(false);
  };
  return /*#__PURE__*/jsxRuntimeExports.jsxs("div", {
    ref: popperContentRef,
    children: [/*#__PURE__*/cloneElement(target, {
      ref: function ref(_ref4) {
        return setTargetElement(_ref4);
      },
      'data-popper-target': true,
      onMouseEnter: trigger === PopperEvent.Hover ? open : null,
      onClick: function onClick(e) {
        var _target$props$onClick, _target$props;
        (_target$props$onClick = (_target$props = target.props).onClick) === null || _target$props$onClick === void 0 || _target$props$onClick.call(_target$props, e);
        trigger === PopperEvent.Click && toggle();
      },
      onMouseLeave: trigger === PopperEvent.Hover ? close : null,
      'data-testid': buttonDataTestId
    }), (isVisible || (isControlled ? isOpen : show)) && getPopperContent(getContent())]
  });
}

export { Popper as P, PopperEvent as a };
//# sourceMappingURL=Popper-ckd24nO1.js.map
